import React from 'react';
import ProgressCard from 'features/invest/components/InvestOnboardingFunnel/ProgressCard';
const AccountCreatedProgressCard = () => (<ProgressCard title="Account created" completed lightBg/>);
export default AccountCreatedProgressCard;
